module.exports = __webpack_public_path__ + "static/assets/f312c8fe232847fc5865dbd7107c35af.svg";